import { PracticeDetailsResponse } from '../../types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { get } from '../apiService';
export const getPracticeById = async (
  id?: string | null
): Promise<{
  data: PracticeDetailsResponse | null;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  if (!id) {
    throw new Error('Id is not available');
  }

  const url = `resourceMatrix/practices/get?practiceId=${id}&customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await get(url);
    const data = responseData as PracticeDetailsResponse;
    loading = false;
    return { data, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to fetch practices item');
  }
};
